/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as m from "react";
import { useTableKeyboardNavigation as b } from "../navigation/hooks.mjs";
const u = (a) => {
  const {
    ariaSort: e,
    colSpan: t,
    rowSpan: r,
    columnId: i,
    navigatable: n,
    ariaColumnIndex: o,
    ariaLabel: l,
    ariaSelected: c,
    ariaDescription: h,
    ...d
  } = a, s = b(i, n);
  return /* @__PURE__ */ m.createElement(
    "th",
    {
      "aria-sort": e,
      "aria-label": l,
      "aria-colindex": o,
      "aria-selected": c,
      colSpan: t,
      rowSpan: r,
      ...s,
      ...d
    },
    a.children
  );
};
u.displayName = "KendoReactHeaderThElement";
export {
  u as HeaderThElement
};
